export class Gradient {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    constructor() {}
}

export const COORDINATES: Gradient[] = [
    { // 1
        x1: 0, x2: 0, y1: 100, y2: 30
    },
    { // 2
        x1: 37, x2: 50, y1: 70, y2: 37
    },
    { // 3
        x1: 30, x2: 40, y1: 50, y2: 37
    },
    { // 4
        x1: 36, x2: 50, y1: 50, y2: 36
    },
    { // 5
        x1: 36, x2: 50, y1: 50, y2: 36
    },
    { // 6
        x1: 36, x2: 50, y1: 50, y2: 36
    },
    { // 7
        x1: 36, x2: 50, y1: 50, y2: 36
    },
    { // 8
        x1: 36, x2: 54, y1: 50, y2: 39
    },
    { // 9
        x1: 36, x2: 54, y1: 50, y2: 50
    },
    { // 10
        x1: 45, x2: 61, y1: 54, y2: 50
    },
    { // 11
        x1: 39, x2: 53, y1: 50, y2: 53
    },
    { // 12
        x1: 39, x2: 50, y1: 50, y2: 53
    },
    { // 13
        x1: 39, x2: 50, y1: 50, y2: 57
    },
    { // 14
        x1: 39, x2: 50, y1: 50, y2: 59
    },
    { // 15
        x1: 39, x2: 50, y1: 50, y2: 59
    },
    { // 16
        x1: 39, x2: 50, y1: 50, y2: 61
    },
    { // 17
        x1: 39, x2: 50, y1: 50, y2: 61
    },
    { // 18
        x1: 39, x2: 50, y1: 50, y2: 65
    },
    { // 19
        x1: 40, x2: 46, y1: 47, y2: 65
    },
    { // 20
        x1: 40, x2: 46, y1: 38, y2: 67
    },
];
